import { COMPANY } from "../lib/company";

/**
 * ContactPage + Organization, with the contact point and the registered
 * address. Reviewers at Meta and Google follow this to confirm the app belongs
 * to a real business at a real address, and the details must match
 * `lib/company.ts` exactly because they are cross-checked against public
 * records.
 */
export function contactStructuredData() {
  return {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: `Contact ${COMPANY.product}`,
    url: `${COMPANY.site}/contact`,
    mainEntity: {
      "@type": "Organization",
      name: COMPANY.legalName,
      alternateName: COMPANY.product,
      url: COMPANY.site,
      address: {
        "@type": "PostalAddress",
        streetAddress: `${COMPANY.address.line1}, ${COMPANY.address.line2}`,
        addressLocality: COMPANY.address.city,
        addressRegion: COMPANY.address.state,
        postalCode: COMPANY.address.postalCode,
        addressCountry: "IN",
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          contactType: "customer support",
          email: COMPANY.supportEmail,
          telephone: COMPANY.phone,
          areaServed: "Worldwide",
          availableLanguage: ["English"],
        },
        {
          "@type": "ContactPoint",
          contactType: "grievance redressal",
          name: COMPANY.grievance.officerName,
          email: COMPANY.grievance.email,
        },
      ],
    },
  };
}
